// Routes/Routes.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CustomizeReport from '../Pages/CustomizeReport/CustomizeReport';
import ReportFinalPage from '../Pages/Report/ReportFinalPage';

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/OTB" element={<CustomizeReport />} />
        <Route path="/OTB-report" element={<ReportFinalPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
